// scripts
import { GMap, MobileMenu } from './scripts/index.js';

// Instantiate a new object using our modules/classes
new MobileMenu();
new GMap();
